export const FALLBACK_REDIRECT = '/projects' as const;
export const AUTH_DEBUG = false as const;
